import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { TemplateBuilder } from "./TemplateBuilder";

export function EditTemplate({ template, templateEdit, editedTemplate }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        variant=""
        className="me-2 w-100"
        onClick={() => setShow(true)}
      >
        <i className="fas fa-edit text-primary" />
      </Button>
      <TemplateBuilder
        mode="edit"
        template={template}
        show={show}
        onHide={() => setShow(false)}
        onSaved={(updated) => {
          setShow(false);
          templateEdit();
          editedTemplate(updated);
        }}
      />
    </>
  );
}
